import { Box, styled } from '@mui/material';

const DatesWrapper = styled(Box)`
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  gap: 8px;
`;

export default DatesWrapper;
